export enum ErrorLevel {
  critical = 'critical',
  warning = 'warning'
}

export class ValidationModel {
  public message: string;
  public level: ErrorLevel;
  constructor(message: string, level: ErrorLevel) {
    this.message = message;
    this.level = level;
  }
}

export type errorMessages = { [key: string]: ValidationModel[] };
